// Phone number formatting utilities
const PhoneFormatter = {
    // Clean phone number (remove all non-digits except +)
    clean: function (phone) {
        return phone.replace(/[^\d+]/g, '');
    },

    // Format phone number for display
    formatForDisplay: function (phone) {
        const cleaned = this.clean(phone);

        // If it starts with +1 (US/Canada)
        if (cleaned.startsWith('+1')) {
            const digits = cleaned.substring(2);
            if (digits.length >= 10) {
                return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
            }
            return cleaned;
        }

        // If it starts with + (international)
        if (cleaned.startsWith('+')) {
            return cleaned;
        }

        // US number without country code
        if (cleaned.length === 10) {
            return `+1 (${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;
        }

        // US number starting with 1
        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            const digits = cleaned.substring(1);
            return `+1 (${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
        }

        return cleaned;
    },

    // Convert to E.164 format
    toE164: function (phone) {
        const cleaned = this.clean(phone);

        // Already in E.164 format
        if (cleaned.startsWith('+')) {
            return cleaned;
        }

        // US number (10 digits)
        if (cleaned.length === 10) {
            return `+1${cleaned}`;
        }

        // US number with leading 1
        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+${cleaned}`;
        }

        // If we can't determine format, assume US
        if (cleaned.length >= 10) {
            return `+1${cleaned.substring(-10)}`;
        }

        return phone; // Return original if can't format
    },

    // Validate E.164 format
    isValidE164: function (phone) {
        return /^\+[1-9]\d{1,14}$/.test(phone);
    }
};